import useModule from "../../hooks/useModule";
import { DynamicContent } from "../../ui/DynamicContent";
import cn from "classnames";

export const Module = ({ className, module_id }) => {
  const moduleData = useModule(module_id);
  return (
    <div className={cn(className)}>
      <DynamicContent
        data={moduleData?.content}
        ContainerComponent={({ children }) => <div>{children}</div>}
        prefix="module"
      />
    </div>
  );
};

export default Module;
